<script setup></script>

<template>
  <div class="loading-page">
    <v-progress-circular :size="70" :width="7" color="#00787C" indeterminate></v-progress-circular>
  </div>
</template>

<style scoped>
.loading-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
